
import React from 'react';
import { Separator } from "@/components/ui/separator";
import { X, Linkedin, Github, Facebook } from 'lucide-react';
import { BUSINESS_IDENTITY } from '@/config/businessIdentity';

export const FooterBottomBar = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="border-t border-gray-800">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 flex flex-wrap items-center gap-2 text-sm text-gray-300 md:mb-0">
            <span>© {currentYear} {BUSINESS_IDENTITY.brandName}. All rights reserved.</span>
            <span aria-hidden="true" className="text-gray-300">|</span>
            <a 
              href="/sitemap.xml" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex min-h-0 items-center py-0.5 transition-colors hover:text-white"
            >
              Sitemap
            </a>
          </div>
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-4">
              <a href={BUSINESS_IDENTITY.social.x} target="_blank" rel="noopener noreferrer" className="inline-flex h-11 w-11 md:h-9 md:w-9 items-center justify-center text-gray-300 transition-colors hover:text-blue-400" aria-label="Follow us on X">
                <X className="h-5 w-5" />
              </a>
              <a href={BUSINESS_IDENTITY.social.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex h-11 w-11 md:h-9 md:w-9 items-center justify-center text-gray-300 transition-colors hover:text-blue-400" aria-label="Follow us on LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href={BUSINESS_IDENTITY.social.github} target="_blank" rel="noopener noreferrer" className="inline-flex h-11 w-11 md:h-9 md:w-9 items-center justify-center text-gray-300 transition-colors hover:text-blue-400" aria-label="View our GitHub">
                <Github className="h-5 w-5" />
              </a>
              <a href={BUSINESS_IDENTITY.social.facebook} target="_blank" rel="noopener noreferrer" className="inline-flex h-11 w-11 md:h-9 md:w-9 items-center justify-center text-gray-300 transition-colors hover:text-blue-400" aria-label="Follow us on Facebook">
                <Facebook className="h-5 w-5" />
              </a>
            </div>
            
            <Separator orientation="vertical" className="h-6 bg-gray-700" />
            
            <div className="text-xs text-gray-400">
              Made in London
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
